import type { CopilotScope } from "@productlane/lib/src/ai"
import { copilotScopeKey } from "@productlane/lib/src/ai"

// The composer takes focus only on an explicit open, and only in the panel the
// request was made for: `panelScope` is the panel's own scope, not the shared
// chat store's, so a request can never focus another surface's composer or
// carry over to the next thread. A page or thread that opens with the copilot
// already active carries no request, so focus stays where the user left it
// (focusing the composer disables the single-key shortcuts).
export function shouldFocusCopilotComposer({
	panelScope,
	isComposerMounted,
	pendingFocusScopeKey,
}: {
	panelScope: CopilotScope
	isComposerMounted: boolean
	pendingFocusScopeKey: string | null
}): boolean {
	if (!isComposerMounted) return false
	return pendingFocusScopeKey === copilotScopeKey(panelScope)
}
